import { z } from "zod";

// 178 -- URL schema hardening.
// Zod 3.x `z.string().url()` only checks parseability, so it accepts script
// schemes like `javascript:` and `data:`. Those values reach `href` / window
// navigation sinks in the portal = XSS. The API has no second line of defense
// (schemas are the only validation), so we constrain every URL-bearing field to
// http(s) here. `max` defaults to 2048 (a generous practical URL cap).
export const httpUrl = (max = 2048) =>
  z
    .string()
    .max(max)
    .refine((v) => /^https?:\/\//i.test(v), {
      message: "Must be an http(s) URL",
    });
